/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const FOCUSABLE_SELECTOR =
	'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

// ブロック単位の状態管理（複数インスタンス対応）
const instances = new Map();

function getFocusableElements(container) {
	return [...container.querySelectorAll(FOCUSABLE_SELECTOR)].filter(
		(el) => el.offsetParent !== null
	);
}

function setupFocusTrap(container, shouldFocusFirst) {
	const trapHandler = (event) => {
		if (event.key !== 'Tab') {
			return;
		}

		const focusableElements = getFocusableElements(container);
		if (focusableElements.length === 0) {
			return;
		}

		const firstElement = focusableElements[0];
		const lastElement = focusableElements[focusableElements.length - 1];
		const activeElement = container.ownerDocument.activeElement;

		if (event.shiftKey && activeElement === firstElement) {
			event.preventDefault();
			lastElement.focus();
		} else if (!event.shiftKey && activeElement === lastElement) {
			event.preventDefault();
			firstElement.focus();
		}
	};

	container.addEventListener('keydown', trapHandler);

	if (shouldFocusFirst) {
		setTimeout(() => {
			const focusableElements = getFocusableElements(container);
			if (focusableElements.length > 0) {
				focusableElements[0].focus({ preventScroll: true });
			}
		}, 100);
	}

	return () => container.removeEventListener('keydown', trapHandler);
}

function doClose(nav, returnFocus) {
	const inst = instances.get(nav);
	if (!inst) {
		return;
	}

	inst.context.isOpen = false;
	if (window.__lenis) {
		window.__lenis.start();
	}

	if (inst.cleanupFocusTrap) {
		inst.cleanupFocusTrap();
	}

	if (returnFocus && inst.triggerElement) {
		inst.triggerElement.focus({ preventScroll: true });
	}

	instances.delete(nav);
}

store('best-anniversary-blocks/drawer-menu', {
	actions: {
		open(event) {
			const { ref } = getElement();
			const nav = ref.closest(
				'.wp-block-best-anniversary-blocks-drawer-menu'
			);
			if (!nav) {
				return;
			}

			// マウスクリック: detail > 0, キーボード: detail === 0
			const isKeyboard = event?.detail === 0;

			if (window.__lenis) {
				window.__lenis.stop();
			}

			const context = getContext();
			context.isOpen = true;

			const drawer = nav.querySelector(
				'.wp-block-best-anniversary-blocks-drawer-menu__drawer'
			);
			const cleanupFocusTrap = drawer
				? setupFocusTrap(drawer, isKeyboard)
				: null;

			instances.set(nav, {
				context,
				triggerElement: ref,
				cleanupFocusTrap,
			});
		},

		close() {
			const { ref } = getElement();
			const nav = ref.closest(
				'.wp-block-best-anniversary-blocks-drawer-menu'
			);
			if (nav) {
				doClose(nav, true);
			}
		},
	},
});

// ESCキーで閉じる（ボタンからの close と同じく、フォーカスをトグルに戻す）
document.addEventListener('keydown', (event) => {
	if (event.key !== 'Escape') {
		return;
	}
	instances.forEach((_, nav) => doClose(nav, true));
});

// ドロワー内のリンククリックで閉じる（ページ遷移するのでフォーカス戻しはしない）
document.addEventListener('click', (event) => {
	const link = event.target.closest('a');
	if (!link) {
		return;
	}

	const nav = link.closest('.wp-block-best-anniversary-blocks-drawer-menu');
	if (!nav || !instances.has(nav)) {
		return;
	}

	// トグルボタン自身の中のリンクは無視
	if (link.closest('.wp-block-best-anniversary-blocks-drawer-menu__toggle')) {
		return;
	}

	doClose(nav, false);
});

// SP: nav-menu-button クリックで親 nav-menu-item の .is-open を切替
document.addEventListener('click', (event) => {
	// SPのみ動作: 画面幅781px以下か確認
	if (window.innerWidth > 781) {
		return;
	}
	const button = event.target.closest('.nav-menu-button');
	if (!button) {
		return;
	}
	const item = button.closest('.nav-menu-item');
	if (!item) {
		return;
	}
	item.classList.toggle('is-open');
	const expanded = item.classList.contains('is-open');
	button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
});
